module.exports = __webpack_public_path__ + "static/img/lwpq.1a439fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/lwpq.jpg
// module id = A/0Z
// module chunks = 171